import { useState, useEffect, useCallback } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import * as api from "../utils/classGroupApi";
import { getArmLabel } from "../utils/classGroupHelpers";

export const useClassGroups = () => {
  const { school } = useStateContext();
  const schoolId = school?._id;
  const isEnabled = school?.settings?.class_grouping_enabled ?? false;
  const subclassLabel = getArmLabel(school);

  const [classGroups, setClassGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchClassGroups = useCallback(async () => {
    if (!schoolId || !isEnabled) {
      setClassGroups([]);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const data = await api.listClassGroups(schoolId);
      setClassGroups(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching class groups:", err);
      // Handle 403 or disabled state gracefully
      if (err?.response?.status === 403) {
        setClassGroups([]);
      } else {
        const msg = api.extractApiErrorMessage(err, "Failed to load class groups");
        setError(msg);
      }
    } finally {
      setLoading(false);
    }
  }, [schoolId, isEnabled]);

  useEffect(() => {
    fetchClassGroups();
  }, [fetchClassGroups]);

  return {
    classGroups,
    loading,
    error,
    isEnabled,
    subclassLabel,
    schoolId,
    refreshClassGroups: fetchClassGroups,
    api,
  };
};

export default useClassGroups;
